import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantGroupDto } from './merchantGroup.dto';

export class BrandDto extends BaseDto {
  id: number;
  merchantGroup?: MerchantGroupDto;
  merchantGroupId: number;
  managerUser?: MerchantDto[];
  name: string;
  photoURL?: string;
  startDate?: Date;
  endDate?: Date;
  primaryColor?: string;
  secondaryColor?: string;
  brandLink?: string;
}
